import { FeatureService } from '@services/feature/feature.service';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http'
import { Router } from '@angular/router'
import { Observable, throwError, forkJoin } from 'rxjs'
import { catchError, tap, map } from 'rxjs/operators'
import { Injectable, Optional } from '@angular/core'
import { Store } from '@ngrx/store'
import { environment } from '@env/environment'

import { LoaderService } from '@app/core/components/loaders/services/loader.service'
import { MessagesService } from '@services/messages/message.service'
import { PATTERN_ISO8601 } from '@app/core/utils/date.util'
import { logOut } from '@app/auth/store/actions/auth.actions'
import { State } from '@app/core/store'
import { CaceisMessages } from '@app/custom-shared/consts/caceis-messages'
import * as moment from 'moment'
import { DatePipe } from '@angular/common'
const PATTERN_NUMBER = /^-?[0-9,.]*$/
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { apiConfig } from '@app/app-config'
import { CookieService } from 'ngx-cookie-service';
import { SharedVariable } from '@app/custom-shared/util/shared-variable';
import { LocalService } from '@app/shared/services/local.service';
import { authService } from '@app/core/services-api/auth.service';

const BASE_PATH_EXTERNAL = environment.basePathExternal
const BASE_PATH_EXTERNAL_API = environment.basePathExternalApi

/**
 * Intercepts and handles an HttpRequest or HttpResponse.
 *
 * This class should not be modified directly.
 */
@Injectable()
export class RequestInterceptorService implements HttpInterceptor {
  constructor(
    private authServices: authService,
    private loaderService: LoaderService,
    public router: Router,
    private msalService: MsalService,
    private featureService: FeatureService,
    private cookieService: CookieService,
    private secureStorage: LocalService,
    public shared: SharedVariable,
  ) { }
  /**
   * Intercepts
   * @param {HttpRequest<any>} req
   * @param {HttpHandler} next
   * @return {Observable<HttpEvent<any>>}
   */

  ignoreNumberParsingURLS = [
    '.*/bff/master/investmentGroup/delete/*'
    
    // '.*/settlementInstructions/*'
  ]
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let blockUnblockUploadMsg, emailMsg,xmlVersion2Error, transactionNotFoundMsg, quotanNotFoundMsg, masterClienteExistsMsg, cpfExistsMsg, nameInstitutionExists, internalServerError,emailCpfMessage: string;
    this.featureService.translatorService.getMessage("blockUnblockUploadMsg").subscribe(
      data => {
        blockUnblockUploadMsg = data;
      }
    )
    this.featureService.translatorService.getMessage("registredEmail").subscribe(
      data => {
        emailMsg = data;
      }
    )
    this.featureService.translatorService.getMessage("registredEmailOrCpf").subscribe(
      data => {
        emailCpfMessage = data;
      }
    )
    this.featureService.translatorService.getMessage("Informe a versão do xml sendo 2, 4 ou 5.").subscribe(
      data => {
        xmlVersion2Error = data;
      }
    )
    this.featureService.translatorService.getMessage("transactionNotFound").subscribe(
      data => {
        transactionNotFoundMsg = data;
      }
    )
    this.featureService.translatorService.getMessage("quotaNotFound").subscribe(
      data => {
        quotanNotFoundMsg = data;
      }
    )
    this.featureService.translatorService.getMessage("masterClienteExists").subscribe(
      data => {
        masterClienteExistsMsg = data;
      }
    )
    this.featureService.translatorService.getMessage("cpfExists").subscribe(
      data => {
        cpfExistsMsg = data;
      }
    )
    this.featureService.translatorService.getMessage("nameInstitutionExists").subscribe(
      data => {
        nameInstitutionExists = data;
      }
    )
    this.featureService.translatorService.getMessage("internalServerError").subscribe(
      data => {
        internalServerError = data;
      }
    )

    let headers = req.headers.append('Accept: "*/*"', 'no-cache');
    headers = req.headers.append('Cache-control', 'no-store');
    headers = req.headers.append('Expires', '0');
    headers = req.headers.append('Pragma', 'no-cache');
    if (!headers.has('Authorization')) {
      headers = req.headers.append('Authorization', 'Bearer ' + this.getTokenFromLocalStorage());
    }
    if (req.url.includes(BASE_PATH_EXTERNAL) || req.url.includes(BASE_PATH_EXTERNAL_API)) {
      if (this.secureStorage.getJsonValue('portfolioCode')) {
        headers = headers.append('PortfolioCode', JSON.parse(this.secureStorage.getJsonValue('portfolioCode')).portfolioCode);
        headers = headers.append('PortfolioConfigCode', JSON.parse(this.secureStorage.getJsonValue('portfolioCode')).identifier);
      }
      headers = headers.append('applicationsrc', 'portalgui')
    }

    // Criteria XSS parse
    if (req.params.get("criteria") !== undefined && req.params.get("criteria") !== null) {
      if ((req.url.includes(BASE_PATH_EXTERNAL) || req.url.includes(BASE_PATH_EXTERNAL_API)) && (req.url.endsWith("/search") || req.url.endsWith("/count"))) {
        var criteria = req.params.get("criteria");
        if(req.urlWithParams&&!req.urlWithParams.includes("fileMessages/search?criteria=filename"))
        req = req.clone({ params: req.params.set("criteria", this.validateXSSCriteria(criteria)) })
      }
    }

    req = req.clone({ headers: headers, url: encodeURI(req.url) })

    // start our loader here
    this.loaderService.show()
    if ((!req.url.includes(BASE_PATH_EXTERNAL)) || (this.getTokenFromLocalStorage() && req.url.includes(BASE_PATH_EXTERNAL))) {
      return next.handle(req.clone({ responseType: 'text' })).pipe(
        map(event => this.parseResponse(event)),
        tap((httpEvent: HttpEvent<any>) => {
          if (httpEvent instanceof HttpResponse) {
            const body = httpEvent.body
            this.convertToDate(body, req)
          }
          // stop loader Service
          this.loaderService.hide()
        }),
        catchError((err: HttpErrorResponse) => {
          this.loaderService.hide()
          // this.messageService.showException(err)
          // CaceisMessages.SERVER_ERROR.showError();
          if ((err.status === 422) && err.error && err.error.apierror && this.router.url !=="/dashboard") {
            if (err.error.apierror.message == "Could not find any transaction for the given date.") {
              transactionNotFoundMsg.showWarn()
            // } else if (err.error.apierror.message == "Could not find any quota for client selected.") {
            //   quotanNotFoundMsg.showWarn()
            // 
            } 
            else if (err.error.apierror.message == "A Master Client user already exists for this institution") {
              masterClienteExistsMsg.showError()
            } else if ((err.url == "https://bff-backoffice-dev.s3caceisinternal.com.br/bff/users/create" && err.error.apierror.message == "Invalid user. Check all mandatory fields") || err.error.apierror.message == "The given e-mail already exists.") {
              console.log("err", err)
              emailMsg.showError()
            } else if (err.error.apierror.message == "The given Investment Group name is unavailable.") {
              nameInstitutionExists.showError()
            }
            else {
              // err.error.apierror.message.showError()
            }

            //this.messageService.showException(err.error.apierror);
          }
          if (err.status === 401) {
            this.logout();
          }
          if((err.status===422)&&err?.error.includes("either cpf or email already registered in the portal")){
            emailCpfMessage.showError()
          }
          if ((err.status === 422) && err.error && err.error.apierror&&this.router.url !=="/dashboard") {
            if (err.error.apierror.message == "The given CPF already exists.")
              cpfExistsMsg.showError()
            if (err.error.apierror.message == "The given Investment Group name is unavailable.")
              nameInstitutionExists.showError()
            }
            if (err.status === 500 && err.url.includes("xmlanbimageneration")&& err.error.description.includes("com.palmyra.arch.exception.ServiceException: Informe a versão do xml sendo 2, 4 ou 5.")) {
              xmlVersion2Error.showError()
              return
               }
               if (err.status === 500 && err.error&& err.error.description&& err.error.description.includes("com.palmyra.arch.exception.ServiceException: User unauthorized to see file: User unauthorized to see file")) {
                return
                 }
          
            if (err.status === 500 && err.error.description === "A JSONArray text must start with '[' at 1 [character 2 line 1]") {
           return
            }
            if (err.status === 500 &&err.error.includes("Missing information(s) from origin operation") && err.url.includes("trading/antecipacaoSwap/findByClientPag")){
              return
               }

            if (err.status === 500 && err.error.errorCode === "No Cetip found for this Contraparte code") {
              return
               }

          if (err.status === 500 && err.error.description === "A JSONArray text must start with '[' at 1 [character 2 line 1]") {
            return
          }

          if (err.status === 500 && err.error.errorCode === "No Cetip found for this Contraparte code") {
            return
          }


          if (err.status === 500 && err.error.apierror ?.customErrorCode == "SC0011"&&this.router.url !=="/dashboard") {
            nameInstitutionExists.showError()
            return
          }

          if (err.url.includes("bff/users/login/first-access")) {
            return
          }
          if(err.status === 500&& err?.url.includes("message/upload")&&err.error.includes("Block/unblock  operations could be managed only via manual Input")){
            blockUnblockUploadMsg.showError()
            return
          }
          // if (err.status === 500 && this.router.url !=="/dashboard") {
          //   internalServerError.showError()
          // }

          if (err.status === 500 && (err.error.description === "JSONArray[0] not found." ||
            err.error.description === "Object of class [com.vermeg.portal.restUtils.RestConfiguration] with identifier [reqReportXML]: optimistic locking failed; nested exception is org.hibernate.StaleObjectStateException: Row was updated or deleted by another transaction (or unsaved-value mapping was incorrect) : [com.vermeg.portal.restUtils.RestConfiguration#reqReportXML]") && req.url.includes("xmlanbimageneration")) {
            let msg: string;
            this.featureService.translatorService.getMessage('no xml anbima').subscribe(
              data => msg = data
            )
            msg.showError()
          }
          let serviceDescription: string = 'com.palmyra.arch.exception.ServiceException: This filename exists for the current user'
          if (err.status === 500 && err.error && err.error.description&& err.error.description.includes(serviceDescription)) {
            let errorMsg: string;
            this.featureService.translatorService.getMessage('Same file name').subscribe(
              data => errorMsg = data
            )
            errorMsg.showError()
          }


          return throwError(err)
        })
      )
    } else {
      setTimeout(() => {
        this.getservice(req, next)
      }, 2000)
    }

  }
  getservice(req, next) {
    if (this.getTokenFromLocalStorage()) {
      return next.handle(req).pipe(
        tap((httpEvent: HttpEvent<any>) => {
          if (httpEvent instanceof HttpResponse) {
            const body = httpEvent.body
            this.convertToDate(body, req)
          }
          // stop loader Service
          this.loaderService.hide()
        }),
        catchError((err: HttpErrorResponse) => {
          this.loaderService.hide()
          // this.messageService.showException(err)
          // CaceisMessages.SERVER_ERROR.showError();
          if ((err.status === 422) && err.error && err.error.apierror&&this.router.url !=="/dashboard") {
            if (err.error.apierror.message == "Could not find any transaction for the given date.") {
              "Não foi possível achar nenhuma transação para a data informada.".showWarn()
            } else if (err.error.apierror.message == "Could not find any quota for client selected.") {
              "Não foi possível achar nenhuma cota para o cliente selecionado.".showWarn()
            } else {
              // err.error.apierror.message.showError()
            }

            //this.messageService.showException(err.error.apierror);
          }
          /* if (err.status === 401) {
            // this.store.dispatch(logOut({}))
           }*/
          return throwError(err)
        })
      )
    } else {
      setTimeout(() => {
        this.getservice(req, next)
      }, 2000)
    }

  }
  /**
   * Converts to date
   * @param body
   */
  private convertToDate(body, rest): void {
    let data = "\\"
    if (body === null || body === undefined) {
      return body
    }
    if (typeof body !== 'object') {
      return body
    }
    for (const key of Object.keys(body)) {
      const value = body[key]
      if (this.isIso8601(value)) {
        if (moment(value, 'YYYY-MM-DD', true).isValid()) {
          body[key] = moment(value).toDate();
        } else {
          body[key] = new Date(value)
        }
      } else if (typeof value === 'object') {
        this.convertToDate(value, rest)
      }
    }
  }

  /**
   * Verifies whether the value respects the iso 8601 or not
   * @param value
   */
  private isIso8601(value: string): boolean {
    if (value === null || value === undefined || PATTERN_NUMBER.test(value)) {
      return false
    }
    return PATTERN_ISO8601.test(value)
  }

  getTokenFromLocalStorage(): string {
    let archive: string = null;
    let keys = Object.keys(localStorage);
    let i = 0;
    let key: string;

    for (; key = keys[i]; i++) {
      if (key.includes("accesstoken")) {
        archive = JSON.parse(localStorage.getItem(key)).secret;
      }
    }

    return archive;
  }

  validateXSSCriteria(criteria: string): string {
    let conditions = criteria.split('&');
    let xssCriteria = "";
    conditions.forEach((item: string) => {
      if (item.includes(">")) {
        xssCriteria = xssCriteria.concat(item + " & ")
      }
    })
    conditions.forEach((item: string) => {
      if (item.includes("<")) {
        xssCriteria = xssCriteria.concat(item + " & ")
      }
    })
    conditions.forEach((item: string) => {
      if (!item.includes("<") && !item.includes(">")) {
        xssCriteria = xssCriteria.concat(item + " & ")
      }
    })
    if (xssCriteria.endsWith("& ")) {
      xssCriteria = xssCriteria.slice(0, -2)
    }
    return xssCriteria;
  }
  logout() {
    this.authServices.logout().subscribe(res => {
    },
      (error) => {
      }, () => {
        sessionStorage.clear();
        let loginDisplay = this.msalService.instance.getAllAccounts()[0];
        const firstWebService$ = this.msalService.acquireTokenSilent({
          account: loginDisplay,
          redirectUri: environment.msalUrl,
          scopes: apiConfig.scopes,
        });
        const secondWebService$ = firstWebService$.pipe(
          map((authResult: any) => {
            return this.msalService.logout({ idTokenHint: `${authResult.idToken}` });
          })  
        );
        forkJoin([firstWebService$, secondWebService$]).subscribe(   
          ([firstResult, secondResult]) => {  
            sessionStorage.clear();  
            localStorage.clear();   
            this.cookieService.deleteAll('/', 'b2clogin.com');   
          },
              (error) => {    
            console.error('Error:', error);   
          }
        );
      })
  }
  private parseResponse(event: HttpEvent<any>): HttpEvent<any> {
    let e :any = event
    if (e.body){
      return event instanceof HttpResponse
      ? event.clone({ body: this.ignoreNumberParsingURLS.findIndex(url => event.url.match(url) != null) < 0 ? this.parseConservingNumbers(event.body) : JSON.parse(event.body) })
      : event;
    }
    return event
    
  }
  parseConservingNumbers(body: string): any {
    if (body !=null){
      let regex = new RegExp(`:\\s(\\d+\\.\\d+|\\d+)(,|\\n)`, "g");
    const newBody = body.replace(regex, (match) => {
      if (match.length > 20) {
        return match.substr(0, 2) + '"' + match.substr(2, match.length - 3) + '"' + match.charAt(match.length - 1)
      }
      return match
    });
    try {
      return JSON.parse(newBody)
    } catch (error) {
      console.warn('error while parsing big numbers ,parsing original object... ');
      return JSON.parse(body)

    }
  }

    }
    
}
